export default {
  backButton: 'All projects',
  backToTheReport: 'Back to the report',
  allReports: 'All reports',
};
